var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadBtn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 7.49994L7.74302 13.2569C6.94386 14.0356 5.87018 14.4681 4.75445 14.4608C3.63873 14.4535 2.57076 14.0071 1.78181 13.2181C0.992855 12.4292 0.546413 11.3612 0.539152 10.2455C0.531892 9.12978 0.964398 8.05609 1.74302 7.25694L7.67202 1.32794C8.20245 0.797506 8.92187 0.499512 9.67202 0.499512C10.4222 0.499512 11.1416 0.797506 11.672 1.32794C12.2025 1.85837 12.5004 2.57779 12.5004 3.32794C12.5004 4.07808 12.2025 4.79751 11.672 5.32794L5.91402 11.0859C5.6488 11.3512 5.28909 11.5002 4.91402 11.5002C4.53894 11.5002 4.17923 11.3512 3.91402 11.0859C3.6488 10.8207 3.4998 10.461 3.4998 10.0859C3.4998 9.71087 3.6488 9.35116 3.91402 9.08594L9.50002 3.49994",
    stroke: "#002E6E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadBtn);
export default __webpack_public_path__ + "static/media/upload-btn.6712dec62d93e18e2ddabf10294b9bc5.svg";
export { ForwardRef as ReactComponent };